<!--  Generated by Paratype Generator -->

<div class="flex flex-col h-full">
  <div class="flex-1 overflow-auto">
    <p-table
      #table
      [value]="entities"
      [rows]="TABLE_ROWS"
      selectionMode="single"
      (onRowSelect)="previewFactura($event)"
      dataKey="id"
      [scrollable]="true"
      scrollHeight="flex"
      [lazy]="true"
      (onLazyLoad)="loadEntitiesLazy($event)"
      class="w-full"
      [showLoader]="false"
      [loading]="loading()"
      size="small"
    >
      <ng-template #caption>
        <div class="flex flex-wrap items-center gap-3 md:flex-nowrap">
          <div class="flex flex-wrap items-center gap-2 md:flex-nowrap md:gap-3">
            <p-button
              label="{{ 'buttons.reset' | transloco }}"
              variant="outlined"
              icon="pi pi-times-circle"
              class="filterButton"
              size="small"
              (onClick)="resetFilter()"
            />
          </div>
          <div class="ml-auto flex w-full flex-wrap items-center gap-3 md:w-auto md:flex-nowrap">
            <p-iconfield class="order-1 w-full md:order-3 md:w-56 lg:w-64">
              <p-inputicon styleClass="pi pi-search" />
              <input
                pInputText
                type="text"
                [(ngModel)]="filter.search_keyword"
                class="w-full"
                placeholder="{{ 'placeholders.search' | transloco }}"
                (input)="searchEntities()"
              />
            </p-iconfield>
            <div class="order-2 flex items-center gap-3 md:order-1">
              <div
                class="flex items-center justify-center text-xs text-gray-600 whitespace-nowrap"
                [ngClass]="{ 'table-entity-count': entitiesCount > entities?.length }"
                (click)="infiniteLimit()"
              >
                {{ 'common.total' | transloco }}: {{ entitiesCount }}
              </div>
            </div>
          </div>
        </div>
        <div class="filter-info">{{ filterStatus() }}</div>
      </ng-template>
      <ng-template #header>
        <tr>
          <th width="auto" pSortableColumn="number">
            {{ 'factura.number' | transloco }}
            <p-sortIcon field="number" />
            <app-table-column-v2 label="number" type="Text" name="number"> </app-table-column-v2>
          </th>
          <th width="auto" pSortableColumn="period">
            {{ 'common.period' | transloco }}
            <p-sortIcon field="period" />
            <app-table-column-v2 label="common.period" type="month" name="period"> </app-table-column-v2>
          </th>
          <th width="auto" pSortableColumn="property__unit_name">
            {{ 'common.property' | transloco }}
            <p-sortIcon field="property__unit_name" />
            <app-table-column-v2 label="common.property" type="Text" name="property__unit_name"> </app-table-column-v2>
          </th>
          <th width="auto" pSortableColumn="owner__name">
            {{ 'owner.name' | transloco }}
            <p-sortIcon field="owner__name" />
            <app-table-column-v2 label="owner.name" type="Text" name="owner__name"> </app-table-column-v2>
          </th>
          <th width="auto" pSortableColumn="balance">
            {{ 'common.balance' | transloco }}
            <p-sortIcon field="balance" />
            <app-table-column-v2 label="common.balance" type="Text" name="balance"> </app-table-column-v2>
          </th>
        </tr>
      </ng-template>
      <ng-template #body let-factura>
        <tr [pSelectableRow]="factura" style="height: 46px">
          <td>{{ factura.number }}</td>
          <td>{{ factura.period ? (factura.period | plainMonth) : '' }}</td>
          <td style="white-space: pre-line">{{ factura.property__unit_name }}</td>
          <td style="white-space: pre-line">{{ factura.owner__name }}</td>
          <td>{{ factura.balance }}</td>
        </tr>
      </ng-template>
      <ng-template #loadingbody let-columns="columns">
        @for (_ of skeletonRows; track _) {
          <tr style="height: 46px">
            @for (col of skeletonColumns; track col; let even = $even) {
              <td>
                <p-skeleton [ngStyle]="{ width: even ? '40%' : '60%' }" />
              </td>
            }
          </tr>
        }
      </ng-template>
    </p-table>
  </div>
</div>
<p-toast position="top-center" />

<p-dialog
  header="{{ 'buttons.previewFactura' | transloco }}"
  [(visible)]="previewDialogVisible"
  [modal]="true"
  [dismissableMask]="true"
  [style]="{ width: '800px' }"
  [contentStyle]="{ height: '1000px' }"
  (onHide)="clearPreviewUrl()"
>
  @if (previewUrl) {
    <iframe class="w-full h-full" [src]="previewUrl" title="Factura preview"></iframe>
  }
</p-dialog>
